/* Live */
export const uniqueID = "b079b91f-f9c4-42ad-b334-faf50132a1b9";
/* export const mainUrl = process.env.REACT_APP_SITE_MAIN_URL; */
export const mainAPIURL = 'https://ecomapi.goepicware.com/'
export const apiUrl = 'https://ecomapi.goepicware.com/api/';
export const epciPayAPIURL = 'https://walletapi.epicpay.ai/api/'
//export const mainUrl = 'https://uat.chirashizushishou.com/';
export const mainUrl = 'https://www.chirashizushishou.com/';

//export const mainUrl = 'https://ecomfront.goepicware.com/';


/* export const mainAPIURL = 'http://localhost:3006/'
export const epciPayAPIURL = 'http://localhost:3005/api/'
export const apiUrl = 'http://localhost:3006/api/'
export const mainUrl = 'http://localhost:3000/'; */

export const deliveryId = "e405c6e5-1526-443d-8809-e149df521133";
export const pickupId = "962ac11f-aaf3-4ba0-8417-b7efb812b939";
export const CountryName = "Singapore";
export const productNoImg = "/img/product-noimg.jpg";
export const companyName = "Chirashizushi Shou";
export const currency = "$";